
import draggable from "vuedraggable";
import { Component, Vue, Prop } from "vue-property-decorator";
import Pop from "../../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import {
  ReportConfigFormat,
  ReportItemFormat
} from "@/lib/model/exambuilder/exam-component/company";
import { ReportShowConfigV5Item } from "@/lib/model/exambuilder/exam-component/report";
import ReportEdit from "./report-edit.vue";

@Component({
  components: {
    ReportEdit,
    draggable,
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class Report extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面

  mounted() {
    // 初始化
    this.init();
  }

  reportConfigFormat: {
    config: ReportItemFormat;
    value: ReportShowConfigV5Item;
  }[] = [];

  get hideReportConfigList() {
    return this.reportConfigFormat.filter(item => item.value.isHidden);
  }

  getDefaultValue(config: ReportItemFormat, index: number) {
    const value = new ReportShowConfigV5Item();

    value.name = config.name;
    value.isHidden = config.canHidden ? this.isEdit : false;
    value.sort = config.canResort ? index : -1;
    value.versionId = config.versionList[0].versionId;

    config.optionList.forEach(item => {
      switch (item.optionType) {
        case "string": {
          return (value.optionMap[item.optionKey] = item.defaultValueString);
        }
        case "bool": {
          return (value.optionMap[item.optionKey] = item.defaultValueBool);
        }
        case "enum": {
          return (value.optionMap[item.optionKey] = item.defaultValueEnum);
        }
      }
    });

    return value;
  }

  async init() {
    const res = await ReportConfigFormat.get();

    res.formatList.forEach((item, index) => {
      const value = this.formItemData.reportConfig.reportShowConfigV5.find(
        vItem => vItem.name === item.name
      );

      this.reportConfigFormat.push({
        config: item,
        value: value || this.getDefaultValue(item, index)
      });
    });
    this.reportConfigFormat.sort((a, b) => {
      if (
        (a.config.isSortHead && b.config.isSortHead) ||
        (a.config.isSortTail && b.config.isSortTail)
      )
        return 0;

      if (a.config.isSortHead) return -1;

      if (a.config.isSortTail) return 1;

      return a.value.sort - b.value.sort;
    });
    this.handleChange();
  }

  checkDraggable(item: {
    config: ReportItemFormat;
    value: ReportShowConfigV5Item;
  }) {
    return item.config.isSortHead || item.config.isSortTail;
  }

  handleMove(e: any) {
    return !this.checkDraggable(e.relatedContext.element);
  }

  selectedParam = "选择模块";

  handleChange() {
    this.formItemData.reportConfig.reportShowConfigV5 = this.reportConfigFormat.map(
      (item, index) => {
        return new ReportShowConfigV5Item().assign({
          ...item.value,
          sort: item.config.canResort ? index : -1
        });
      }
    );
  }

  // 编辑
  showRegis = false;
  editParam: {
    config: ReportItemFormat;
    value: ReportShowConfigV5Item;
  } | null = null;

  editOk() {
    this.showRegis = false;
    this.handleChange();
  }

  editClose() {
    this.showRegis = false;
  }

  edit(item: { config: ReportItemFormat; value: ReportShowConfigV5Item }) {
    this.editParam = item;
    this.showRegis = true;
  }

  select(item: { config: ReportItemFormat; value: ReportShowConfigV5Item }) {
    item.value.isHidden = false;
    this.handleChange();
  }

  hide(item: { config: ReportItemFormat; value: ReportShowConfigV5Item }) {
    item.value.isHidden = true;
    this.handleChange();
  }

  // 校验数据
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }
}
